import React from 'react';
import { useParams } from 'react-router-dom';

// Existing imports
import TmtSteel from './SteelCategories/TmtSteel';
import Angle from './StructuralSteel/Angle';
import HotRolledSheets from './SteelCategories/MildSteel/HotRolledSheets';
import ColdRolledSheets from './SteelCategories/MildSteel/ColdRolledSheets';
import HotRolledCoils from './SteelCategories/MildSteel/HotRolledCoils';
import HRPOCoils from './SteelCategories/MildSteel/HRPOCoils';
import HRPOSheets from './SteelCategories/MildSteel/HRPOSheets';
import ColdRolledCoils from './SteelCategories/MildSteel/ColdRolledCoils';
import WireRodCoils from './SteelCategories/MildSteel/WireRodCoils';
import GalvanizedCoils from './SteelCategories/MildSteel/GalvanizedCoils';
import GalvanizedSheets from './SteelCategories/MildSteel/GalvanizedSheets';
import GalvalumeCoils from './SteelCategories/MildSteel/GalvalumeCoils';

// Stainless Steel
import StainlessSteel from './StainlessSteel/StainlessSteel';
import StainlessSteelPipe from './StainlessSteel/StainlessSteelPipe';
import StainlessSteelBar from './StainlessSteel/StainlessSteelBar';

// Structural
import Angles from './StructuralSteel/Angles/Angles';

// Pipes
import ERWPipe from './PipeCategories/ERWPipe';
import SeamlessPipe from './PipeCategories/SeamlessPipe';
import DuctilePipe from './PipeCategories/DuctilePipe';
import DuctileIron from './PipeCategories/DuctileIron';
import SpiralWeldedPipe from './PipeCategories/SpiralWeldedPipe';
import RCCPipe from './PipeCategories/RCCPipe';
import Polymer from './Polymer/Polymer';

const CategoryPageWrapper = () => {
	const { slug } = useParams();

	const structuralSteel = ['angles', 'channels', 'beams'];

	const stainlessSteelCommon = [
		"stainless-steel-hot-rolled-coils",
		"stainless-steel-hot-rolled-sheets",
		"stainless-steel-cold-rolled-coils",
		"stainless-steel-cold-rolled-sheets"
	];
	const stainlessSteelIndividual = {
		"stainless-steel-pipe": <StainlessSteelPipe />,
		"stainless-steel-bar": <StainlessSteelBar />
	};

	const pipeCategoryMap = {
		"erw-pipes": <ERWPipe />,
		"seamless-pipes": <SeamlessPipe />,
		"ductile-pipes": <DuctilePipe />,
		"ductile-iron": <DuctileIron />,
		"spiral-welded-pipes": <SpiralWeldedPipe />,
		"rcc-pipes": <RCCPipe />
	};

	if (slug === 'tmt-bar') return <TmtSteel />;
	if (slug === 'stainless-steel') return <StainlessSteel />;

	if (slug === 'polymer') return <Polymer />;

	if (slug in stainlessSteelIndividual) return stainlessSteelIndividual[slug];
	if (stainlessSteelCommon.includes(slug)) return <StainlessSteel />;
	if (slug in pipeCategoryMap) return pipeCategoryMap[slug];
	if (structuralSteel.includes(slug)) return <Angle />;

	switch (slug) {
		case 'hot-rolled-sheets':
			return <HotRolledSheets />;
		case 'hot-rolled-coils':
			return <HotRolledCoils />;
		case 'hrpo-coils':
			return <HRPOCoils />;
		case 'hrpo-sheets':
			return <HRPOSheets />;
		case 'cold-rolled-coils':
			return <ColdRolledCoils />;
		case 'cold-rolled-sheets':
			return <ColdRolledSheets />;
		case 'wire-rod-coils':
			return <WireRodCoils />;
		case 'galvanized-coils':
			return <GalvanizedCoils />;
		case 'galvanized-sheets':
			return <GalvanizedSheets />;
		case 'galvalume-coils':
			return <GalvalumeCoils />;
		default:
			return <div>Category not found</div>;
	}

};

export default CategoryPageWrapper;
